import { render, staticRenderFns } from "./InformationVWA.vue?vue&type=template&id=095b91c6&scoped=true&"
import script from "./InformationVWA.vue?vue&type=script&lang=ts&"
export * from "./InformationVWA.vue?vue&type=script&lang=ts&"
import style0 from "./InformationVWA.vue?vue&type=style&index=0&id=095b91c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095b91c6",
  null
  
)

export default component.exports